// TODO enable eslint
/* eslint-disable import/no-self-import */
import * as thisModule from "./category"

export const getId = category => category.id
export const getName = category => category.name

export default thisModule
